<template>
  <div id="profile">
    <the-top-bar title="Profile" />
    <div class="backButton">
      <button @click="$router.go(-1)" class="btn-floating btn-small waves-effect white ">
        <i class="material-icons grey-text text-darken-3 left">arrow_back</i>
      </button>
    </div>
 
    <div class=" content">
   <div class="profile-icon">
      <i class="material-icons-outlined">
        account_circle
      </i>
    </div>

      <div class="card">
        <div class="card-content">
          <div class="input-field col s12">
            <div class="">New Password</div>
            <input id="passowrd" type="password" class="validate" v-model="user.password" />
            
          </div>
          <div class="input-field col s12">
            <div class="">Confirm Password</div>
            <input id="password_2" type="password" class="validate" v-model="user.confirmPassword" />
            <span class="helper-text red-text" v-if="error">Passwords do not match.</span>
          </div>
        </div>
      </div>
    </div>
    <div class="control-bar z-depth-1 row">
      <button class="btn btn-flat waves-effect btn-rounded white black-text col s5 m2" @click="$_goTo()">
        Cancel
      </button>

      <button class="btn waves-effect amber lighten-1 btn-rounded black-text col s5 m2 right shadow-depth" @click="$_saveData()" :disabled="isProcessing">
        Save
      </button>
    </div>
  </div>
</template>
<script>
import TheTopBar from "@/components/TheTopBar.vue";
import { updateUser } from "@/api/user.api";
import M from "materialize-css";
export default {
  components: { TheTopBar },
  name: "Profile",
  props: {},
  data() {
    return {
      isProcessing: false,
      user: {
        password: "",
        confirmPassword: "",
      },
      error: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    $_saveData() {
      if (this.isProcessing || !this.user.password || !this.user.confirmPassword) return;

      this.isProcessing = true;

      //Check if passwords match
      if (this.user.password !== this.user.confirmPassword) {
        this.error = true;
        return;
      }

      updateUser(this.$store.state.User.user.id, { ...this.user })
        .then((res) => {
          this.isProcessing = false;

          M.toast({ html: "Password Updated Successfully!" });
        })
        .catch((err) => {
          M.toast({ html: "OOPS!Something went wrong." });
        });
    },
    $_goTo() {
      this.$router.push({ name: "Account" });
    },
  },
};
</script>
<style lang="scss" scoped>
#profile {
 .profile-icon {
  text-align: center;
  padding-top: 12px;
    &::after {
      content: 'Edit Profile';
      text-align: center;
      display: block;
      margin-bottom: 15px;
      font-size: 22px;
      line-height: 1;
    }
    i {
      font-size: 84px;
      color: #252525;
    }
  }
  .backButton {
    left: 50%;
    position: fixed;
    @media screen and (max-width:768px) {
      top: 84px;
    }
    top: 124px;
    max-width: 690px;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 14px;
  }
  .control-bar {
    position: fixed;
    left: 0;
    bottom: 0;
    height: 60px;
    width: 100%;
    padding: 1rem;
    margin: 0 !important;
    background: #fff;
  }
   .content {
    max-width: 690px;
    padding: 16px;
    margin: auto;
    .card-content {
      padding: 0 24px;
    }
  }

}
</style>
